export default function PendingMessage() {
  return (
    <div
      className="bg-white border border-neutral-200 rounded-2xl rounded-tl-sm shadow-sm p-5 max-w-3xl space-y-3"
      role="status"
      aria-live="polite"
      aria-label="Assistant is thinking"
    >
      <div className="h-3 w-24 bg-neutral-200 rounded animate-pulse" />
      <div className="h-5 w-3/4 bg-neutral-200 rounded animate-pulse" />
      <div className="flex gap-2">
        <div className="h-14 w-28 bg-neutral-100 rounded-lg animate-pulse" />
        <div className="h-14 w-28 bg-neutral-100 rounded-lg animate-pulse" />
      </div>
      <div className="space-y-1.5 pt-1">
        <div className="h-2 w-full bg-neutral-200 rounded animate-pulse" />
        <div className="h-2 w-5/6 bg-neutral-200 rounded animate-pulse" />
        <div className="h-2 w-2/3 bg-neutral-200 rounded animate-pulse" />
      </div>
      <p className="text-xs text-neutral-500 italic">Thinking — this may take a few seconds…</p>
    </div>
  );
}
